<ng-template #createModal let-modal>
  <form #f="ngForm" (ngSubmit)="f.form.valid && modal.close(eventModel)">
    <div class="modal-header justify-content-center">
      <h4 class="title">{{ title }}</h4>
    </div>
    <div class="modal-body">
      <div>
        <label>Name</label>
        <div class="form-group mb-3">
          <input
            type="text"
            name="name"
            [(ngModel)]="eventModel.name"
            class="form-control"
            [class.is-invalid]="!isValidName()"
            autocomplete="off"
            required
          />
          <div *ngIf="!isValidName()" class="invalid-feedback">Name cannot contain spaces or be empty.</div>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Description</label>
        <textarea
          type="text"
          #description="ngModel"
          name="description"
          class="form-control"
          [(ngModel)]="eventModel.description"
          [ngClass]="{ 'is-invalid': f.submitted && (description.invalid)}"
        ></textarea>
      </div>
      <div>
        <label>Location</label>
        <div class="form-group mb-3">
          <input
            type="text"
            name="location"
            [(ngModel)]="eventModel.location"
            class="form-control"
            [class.is-invalid]="!isValidLocation()"
            autocomplete="off"
            required
          />
        </div>
      </div>

      <div>
        <label>Capacity</label>
        <div class="form-group mb-3">
          <input
            type="text"
            name="capacity"
            [(ngModel)]="eventModel.capacity"
            class="form-control"
            [class.is-invalid]="!isValidCapacity()"
            autocomplete="off"
            required
          />
          <div *ngIf="!isValidCapacity()" class="invalid-feedback">Capacity has to be at least 1.</div>
        </div>
      </div>

      <div class="datepicker-container row">
        <div class="col-md-8">
          <label>Start Date</label>
          <div class="form-group mb-3">
            <input
              type="text"
              name="startDate"
              [(ngModel)]="eventModel.startDate"
              class="form-control datetimepicker"
              [class.is-invalid]="!eventModel.startDate"
              placeholder="yyyy-mm-dd"
              ngbDatepicker
              #startDate="ngbDatepicker"
              (click)="startDate.toggle()"
              required
            />
          </div>
        </div>
        <div class="col-md-4">
          <label>Start Time</label>
          <div class="form-group">
            <ngb-timepicker
              name="startTime"
              [(ngModel)]="eventModel.startTime"
              [class.is-invalid]="!eventModel.startTime"
              [spinners]="false"
              required
            ></ngb-timepicker>
            <div *ngIf="!eventModel.startTime" class="invalid-feedback">Please enter a start time.</div>
          </div>
        </div>
      </div>
      <div class="datepicker-container row">
        <div class="col-md-8">
          <label>End Date</label>
          <div class="form-group mb-3">
            <input
              type="text"
              name="endDate"
              [(ngModel)]="eventModel.endDate"
              class="form-control datetimepicker"
              [class.is-invalid]="!eventModel.endDate"
              placeholder="yyyy-mm-dd"
              ngbDatepicker
              #endDate="ngbDatepicker"
              (click)="endDate.toggle()"
              required
            />
          </div>
        </div>
        <div class="col-md-4">
          <label>End Time</label>
          <div class="form-group">
            <ngb-timepicker
              name="endTime"
              [(ngModel)]="eventModel.endTime"
              [class.is-invalid]="!eventModel.endTime"
              [spinners]="false"
              required
            />
            <div *ngIf="!eventModel.endTime" class="invalid-feedback">Please enter a end time.</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel')">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="!isValidModal()">Submit</button>
    </div>
  </form>
</ng-template>

<ng-template #listModal let-listModal>
  <div class="modal-header justify-content-center">
    <h4 class="title">Bookings</h4>
  </div>
  <div class="modal-body justify-content-center">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="text-primary">
          <tr>
            <th>Firstname</th>
            <th>Lastname</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let b of bookings | async">
            <td>{{b.firstname}}</td>
            <td>{{b.lastname}}</td>
            <td>{{b.email}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="listModal.dismiss('cancel')">Close</button>
  </div>
</ng-template>

<div class="main-content">
  <div class="container-fluid mt-4">
    <div class="card">
      <div class="card-header">
        <h3>
          Events
          <span class="btn-wrapper" placement="top" [ngbTooltip]="canEdit? '':'Insufficent permission'" container="body">
            <button type="button" class="btn btn-primary btn-sm" [disabled]="!canEdit" (click)="resetModel(); open($event, createModal)">
              <fa-icon [icon]="['fal','plus']"></fa-icon> Create Event
            </button>
          </span>
        </h3>
        <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="calendar" size="lg" [fixedWidth]="true"> </fa-icon>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="text-primary">
              <tr>
                <th>Name</th>
                <th>Location</th>
                <th>Booked</th>
                <th>Capacity</th>
                <th>Start date</th>
                <th>End date</th>
                <th class="text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of events | async" (click)="getBookings(e.id); open($event, listModal)" class="event-row">
                <td>{{e.name}}</td>
                <td>{{e.location}}</td>
                <td>{{e.booked}}</td>
                <td>{{e.capacity}}</td>
                <td>{{e.startTime | date:dateTimeFormat}}</td>
                <td>{{e.endTime | date:dateTimeFormat}}</td>
                <td class="text-right">
                  <button
                    [disabled]="!canEdit"
                    type="button"
                    class="btn btn-light me-1 btn-sm"
                    (click)="setModel(e); open($event, createModal);"
                  >
                    <fa-icon [fixedWidth]="true" [icon]="['fal', 'cog']"></fa-icon>
                  </button>
                  <button
                    ngbTooltip="Bookings"
                    type="button"
                    class="btn btn-success me-1 btn-sm"
                    (click)="getBookings(e.id); open($event, listModal)"
                  >
                    <fa-icon [fixedWidth]="true" [icon]="['fal', 'calendar']"></fa-icon>
                  </button>
                  <button
                    [disabled]="!canDelete"
                    type="button"
                    class="btn btn-danger btn-sm"
                    (click)="deleteSwalOptions(e); $event.stopPropagation()"
                  >
                    <fa-icon [fixedWidth]="true" [icon]="['fal','trash']"></fa-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
